export { default } from './ExternalCardBlock';
export * from './ExternalCardBlock';
